// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Cta = require("../../../atom/Atom_Cta.bs.js");
var Atom_Row = require("../../../atom/Atom_Row.bs.js");
var Atom_Cell = require("../../../atom/Atom_Cell.bs.js");
var UseOnBlur = require("../../../../hook/UseOnBlur.bs.js");
var UseToggle = require("../../../../hook/UseToggle.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Util_Array = require("../../../../util/Util_Array.bs.js");
var Atom_Column = require("../../../atom/Atom_Column.bs.js");
var Type_Header = require("../../../../type/Type_Header.bs.js");
var Atom_Divider = require("../../../atom/Atom_Divider.bs.js");
var UseClickOutside = require("../../../../hook/UseClickOutside.bs.js");
var Particle_Screen_Ds = require("../../../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../../../particle/Particle_Spacer_Ds.bs.js");
var Particle_Background_Ds = require("../../../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../../../particle/Particle_Screen_Constants.bs.js");

var innerSpaceListColumn = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");

function Organism_Concert_SelectGenre$ListItem(Props) {
  var items = Props.items;
  if (items !== undefined) {
    return React.createElement(Atom_Column.make, {
                children: Belt_Array.map(items, (function (item) {
                        return React.createElement(Atom_Cta.Link.make, {
                                    href: item.href,
                                    label: item.label,
                                    style: {
                                      TAG: /* Header */10,
                                      _0: /* GenreItem */5
                                    },
                                    key: item.label
                                  });
                      })),
                innerSpace: innerSpaceListColumn
              });
  } else {
    return null;
  }
}

var ListItem = {
  innerSpaceListColumn: innerSpaceListColumn,
  make: Organism_Concert_SelectGenre$ListItem
};

var rowBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.make("S", "M", "L", "XL", undefined));

var dividerBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("M"));

function getChunkSize(selectGenre) {
  return (selectGenre.items.length >> 1);
}

var containerRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("absolute"),
      CssJs.top({
            NAME: "px",
            VAL: Type_Header.Constants.height.m
          })
    ]);

var containerBlockspace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("M"));

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeLeft("L"));

function Organism_Concert_SelectGenre(Props) {
  var selectGenre = Props.selectGenre;
  var match = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match.close;
  var state = match.state;
  var containerRef = React.useRef(null);
  UseClickOutside.make(containerRef, close);
  UseOnBlur.make(containerRef, close);
  var chunkedSelectGenre = Util_Array.chunk(selectGenre.items, getChunkSize(selectGenre));
  var dropContent = state ? null : React.createElement(Atom_Column.make, {
          background: Particle_Background_Ds.selectConcertGenre,
          blockSpace: containerBlockspace,
          children: React.createElement(Atom_Row.make, {
                blockSpace: rowBlockSpace,
                children: null,
                wrap: /* OnOneLine */1
              }, React.createElement(Organism_Concert_SelectGenre$ListItem, {
                    items: Belt_Array.get(chunkedSelectGenre, 0)
                  }), React.createElement(Atom_Cell.make, {
                    blockSpace: dividerBlockSpace,
                    children: React.createElement(Atom_Divider.make, {
                          style: Atom_Divider.headerSocialLink
                        })
                  }), React.createElement(Organism_Concert_SelectGenre$ListItem, {
                    items: Belt_Array.get(chunkedSelectGenre, 1)
                  })),
          rules: containerRules
        });
  return React.createElement(Atom_Column.make, {
              alignItems: Particle_Screen_Constants.alignItemsFlexStart,
              blockSpace: blockSpace,
              children: null,
              ref_: containerRef
            }, React.createElement(Atom_Cta.Button.make, {
                  label: selectGenre.title.label,
                  onClick: match.toggle,
                  style: {
                    TAG: /* Header */10,
                    _0: {
                      TAG: /* ConcertGenre */15,
                      _0: state
                    }
                  }
                }), dropContent);
}

var make = Organism_Concert_SelectGenre;

exports.ListItem = ListItem;
exports.rowBlockSpace = rowBlockSpace;
exports.dividerBlockSpace = dividerBlockSpace;
exports.getChunkSize = getChunkSize;
exports.containerRules = containerRules;
exports.containerBlockspace = containerBlockspace;
exports.blockSpace = blockSpace;
exports.make = make;
/* innerSpaceListColumn Not a pure module */
